import Vue from "vue"
import Router from "vue-router"
import Index from "./views/index.vue"
import Login from "./views/login.vue"
import Muuri from "./views/muuri.vue"
import Test from "./views/drop.vue"
import workSpace from "./views/workSpace/default.vue"
import Analyse from "./views/analysis/index.vue"
import Total from "./views/analysis/total.vue"
import Classify from "./views/analysis/classify.vue"
import Detail from "./views/workSpace/detail.vue"
import PatentMap from "./views/workSpace/patentMap.vue"
import Search from "./views/search/searchIndex.vue"
import Result from "./views/search/result.vue"
import PatentInfo from "./views/search/patentInfo.vue"
import FolderList from "./views/workSpace/folderList.vue"
import Work from "./views/workSpace/work.vue"
import Business from "./views/business/index.vue"
import History from "./views/userInfo/history.vue"
import BaseData from "./views/userInfo/baseData.vue"
import Manage from "./views/firm/manage.vue"
import Sort from "./views/firm/sort.vue"
import Category from "./views/firm/category.vue"
import Chome from "./views/firm/chome.vue"

import Knowledge from "./views/firm/knowledge.vue"
import categoryDetail from "./views/firm/categoryDetail.vue"

import enteRaing from "./views/firm/enteRaing.vue"
import Report from "./views/report/index.vue"
import ReportNew from "./views/report/new.vue"
import ReportList from "./views/report/list.vue"
import ReportEmail from "./views/report/email.vue"
import Download from "./views/report/download.vue"
import Home from "./views/home.vue"
import Help from "./views/search/help.vue"
import Manager from "./views/manager/index.vue"
import ManagerSet from "./views/manager/setting.vue"
import ManagerMsg from "./views/manager/msgset.vue"
//import Demo from './views/demo/side/demo.vue'
//重构search
import Research from "./views/search/Research/index.vue"
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    routes: [{
            path: "/",
            redirect: "/home"
        },
        {
            path: "/home",
            name: "home",
            component: Home
        },
        {
            path: "/",
            redirect: "/login"
        },
        {
            path: "/login",
            name: "login",
            component: Login
        },
        {
            path: "/index",
            name: "index",
            component: Index
        },
        {
            path: "/muuri",
            name: "muuri",
            component: Muuri
        },
        {
            path: "/test",
            name: "test",
            component: Test
        },
        // {
        //     path:'/demo',
        //     name:'name',
        //     component:Demo
        // },
        {
            path: "/workSpace",
            name: "workSpace",
            component: workSpace,
            redirect: "/workSpace/work",
            children: [{
                    path: "/workSpace/work",
                    name: "workSpace-work",
                    component: Work
                },
                {
                    path: "/workSpace/folder",
                    name: "workSpace-folder",
                    component: FolderList
                },
                {
                    path: "/workSpace/detail",
                    name: "workSpace-detail",
                    component: Detail
                }
            ]
        },
        {
            path: "/user/history",
            name: "user-history",
            component: History
        },
        {
            path: "/user/baseData",
            name: "user-baseData",
            component: BaseData
        },
        {
            path: "/analySet",
            name: "analySet",
            component: Total
        },
        {
            path: "/analyse",
            name: "analyse",
            component: Analyse
                // redirect: '/analyse/classify/all',
                // children: [
                //     {
                //         path: '/analyse/classify/:id',
                //         component: Classify
                //     }
                // ]
        },
        {
            path: "/analyse/classify/:id",
            component: Classify
        },
        {
            path: "/workSpace/patentMap",
            name: "workSpace-patentMap",
            component: PatentMap
        },
        {
            path: "/search",
            name: "search",
            component: Search
        },
        //重构的路由
        {
            path: "/research",
            name: "research",
            component: Research
        },
        {
            path: "/search/result",
            name: "searchResult",
            component: Result
        },
        {
            path: "/search/patentInfo/:id",
            name: "patentInfo",
            component: PatentInfo
        },
        {
            path: "/business",
            name: "business",
            component: Business
        },
        {
            path: "/manage",
            name: "manage",
            component: Manage,
            children: [{
                path: "/manage/sort",
                name: "manage-sort",
                component: Sort
            }]
        },
        {
            path: "/category",
            name: "category",
            component: Category
        },
        {
            path: "/knowledge",
            name: "knowledge",
            component: Knowledge
        },
        {
            path: "/categoryDetail",
            name: "categoryDetail",
            component: categoryDetail
        },
        {
            path: "/enteRaing",
            name: "enteRaing",
            component: enteRaing
        },
        {
            path: "/chome",
            name: "chome",
            component: Chome
        },
        {
            path: "/report",
            name: "report",
            component: Report
        },
        {
            path: "/report/new",
            name: "report-new",
            component: ReportNew
        },
        {
            path: "/report/:id",
            name: "report-id",
            component: ReportList
        },
        {
            path: "/report/email/:id",
            name: "report-email",
            component: ReportEmail
        },
        {
            path: "/report/download/:id",
            name: "report-download",
            component: Download
        },
        {
            path: "/help",
            name: "help",
            component: Help
        },
        {
            path: "/manager",
            name: "manager",
            component: Manager
        },
        {
            path: "/manager/setting",
            name: "manager-setting",
            component: ManagerSet
        },
        {
            path: "/manager/msgset",
            name: "manager-msgset",
            component: ManagerMsg
        }
    ]
})